<template>
  <div>
    <div class="upload-file col-12">
      <vue-easy-lightbox escDisabled :visible="previewAttachment.visible" :imgs="previewAttachment.imgs"
        :index="previewAttachment.index" @hide="handleHidePreviewAttachment" />

      <div>
        <b-col class="preview-img-container mb-4" v-if="isLoadAttachmentSuccess">
          <div>
            <!--File Previews-->
            <div class="d-flex flex-wrap" style="gap: 16px;">
              <div v-for="(item, index) in attachments" :key="index" class="img-container align-items-start">
                <img v-if="checkTypeFile(item.fileName)" :src="item.url" class="preview-img" width="80" height="100"
                  :alt="item.originalName" @click="showMultiplePreViewAttachment(index)" style="cursor:pointer" />
                <img v-else src="@/assets/google-docs.svg" class="preview-img" width="80" height="100"
                  :alt="item.originalName" />
                <i class="fas fa-times-circle text-danger close" @click="deleteAttachment(item)"></i>
                <small class="text-black">
                  {{ item.originalName }}
                </small>
                <template v-if="!checkTypeFile(item.fileName)">
                  <a :download="item.fileName" :href="item.url" target="_blank" title="Tải xuống">
                    <i class="fas fa-arrow-circle-down text-warning remove"></i>
                  </a>
                </template>

              </div>
            </div>
          </div>
        </b-col>

        <!--UPLOAD-->
        <form id="form-upload" enctype="multipart/form-data" novalidate class="mb-4" v-if="isAllowUpload">
          <b-button size="sm" variant="secondary" @click="openFiles()" class="font-weight-bolder mr-2"
            :disabled="isSaving">
            <i class="fas fa-paperclip"></i>
            Đính kèm tệp
          </b-button>
          <b-button size="sm" variant="warning" @click="submitFiles()" class="font-weight-bolder"
            v-if="uploadedFiles.length" :disabled="isSaving">
            <i class="fas fa-upload"></i>
            Tải tệp lên
          </b-button>
          <b-form-file v-model="fileAttach.files" ref="upload-files" id="upload-files" class="mb-2 d-none input-file"
            multiple :name="uploadFieldName" :disabled="isSaving" @change="handleFileUpload" />

          <p v-if="isSaving">Đang tải {{ fileCount }} tệp...</p>
          <div v-if="isFailed" class="d-flex align-items-center">
            <small class="text-danger mr-2">Tải tệp thất bại.</small>
            <b-button size="sm" variant="outline-secondary" @click="reset()" class="ml-2">
              Thử lại
            </b-button>
            <pre class="mb-0 ml-2">{{ uploadError }}</pre>
          </div>
        </form>
        <b-col class="preview-img-container mb-4" v-if="uploadedFiles.length > 0">
          <div>
            <!--File Previews-->
            <div class="d-flex flex-wrap" style="gap: 16px;">
              <div v-for="(item, index) in uploadedFiles" :key="index" class="img-container align-items-start">
                <img v-if="typecheck(item.fileName)" :src="item.url" class="preview-img" width="80" height="100"
                  :alt="item.originalName" @click="showMultiplePreViewFile(index)" style="cursor:pointer" />
                <img v-else src="@/assets/google-docs.svg" class="preview-img" width="80" height="100"
                  :alt="item.originalName" />
                <i class="fas fa-times-circle text-danger close" @click="
                  removeFile(
                    fileCount,
                    uploadedFiles.indexOf(item),
                  )
                  ">
                </i>
              </div>
            </div>
          </div>
        </b-col>
        <!--SUCCESS-->
        <p v-if="isSuccess">
          <b>Tổng số {{ uploadedFiles.length }} tệp</b>
        </p>
        <!--FAILED-->
      </div>
    </div>
  </div>
</template>

<style scoped>
.upload-file .d-flex {
  gap: 16px;
}

.img-container {
  position: relative;
  display: inline-block;
  width: 80px;
}

.preview-img {
  max-width: 80px;
  padding: 10px;
  object-fit: contain;
  border: 1px solid #eeecff;
  border-radius: 5px;
}

.close {
  position: absolute;
  top: 0px;
  right: 0px;
  width: 15px;
}

.remove {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 15px;
}
</style>

<script>
import ApiService from '@/core/services/api.service';
import {
  makeToastFaile,
  makeToastSuccess,
} from '@/utils/common';
import VueEasyLightbox from 'vue-easy-lightbox';
import {
  generateImage,
  checkTypeFile,
  typecheck,
  getApiUrlByEntity
} from '@/utils/common-upload-files';
import axios from 'axios';
import { FILE_UPLOAD_STATUS, FILE_UPLOAD_MODE } from '@/utils/enum';

const STATUS_SUCCESS = 2
export default {
  props: {
    id: {
      type: [String, Number],
      default: null,
    },
    entity: {
      type: String,
      default: '',
    },
    isAllowUpload: {
      type: Boolean,
      default: true,
      required: false,
    },
  },
  components: {
    VueEasyLightbox,
  },
  data() {
    return {
      previewAttachment: {
        visible: false,
        imgs: '',
        index: 0,
      },
      attachments: [],
      isLoadAttachmentSuccess: false,
      fileAttach: {
        files: [],
        fileModels: [],
      },
      currentStatus: FILE_UPLOAD_MODE.INITIAL,
      uploadedFiles: [],
      uploadFieldName: 'photos',
      fileCount: 0,
    };
  },
  created() {
    this.loadAttachments();
  },
  mounted() { },
  watch: {},
  computed: {
    isInitial() {
      return this.currentStatus === FILE_UPLOAD_MODE.INITIAL;
    },
    isSaving() {
      return this.currentStatus === FILE_UPLOAD_MODE.SAVING;
    },
    isSuccess() {
      return this.currentStatus === FILE_UPLOAD_MODE.SUCCESS;
    },
    isFailed() {
      return this.currentStatus === FILE_UPLOAD_MODE.FAILED;
    },
  },
  methods: {
    checkTypeFile,
    typecheck,
    getApiUrlByEntity,
    openFiles() {
      if (this.$refs['upload-files'] && this.$refs['upload-files'].$el) {
        const input = this.$refs['upload-files'].$el.querySelector('input[type="file"]');
        if (input) input.click();
      }
    },
    deleteAttachment(item) {
      const apiUrl = getApiUrlByEntity(this.entity);

      if (item.state === FILE_UPLOAD_STATUS.NEW) {
        const key = this.attachments.findIndex(el => el.id === item.id);
        if (key !== -1) this.attachments.splice(key, 1);
      } else {
        ApiService.delete(`${apiUrl.root}/${item.id}`)
          .then(res => {
            if (res.data && res.data.status === 1) {
              this.loadAttachments();
              makeToastSuccess('Xóa tệp thành công!');
            } else {
              makeToastFaile('Xóa tệp thất bại!');
            }
          })
          .catch(() => {
            makeToastFaile('Xóa tệp thất bại!');
          });
      }
    },
    loadAttachments() {
      const apiUrl = getApiUrlByEntity(this.entity);
      this.isLoadAttachmentSuccess = false;

      ApiService.query(apiUrl.root, {
        params: {
          entity: this.entity,
          entityId: this.id,
        },
      }).then(async (resp) => {
        if (resp.data.status === 1) {
          const attachments = resp.data.data.map((item) => ({
            id: item.id,
            fileName: item.fileName,
            originalName: item.name,
            path: item.path,
          }));
          if (!attachments || attachments.length === 0) {
            this.attachments = [];
            this.isLoadAttachmentSuccess = true;
            return;
          }

          this.attachments = await Promise.all(
            attachments.map(async (attachment) => {
              try {
              const response = await axios.get(
              `${apiUrl.preview}`, {
                params: {
                  fileName: attachment.fileName,
                  entity: this.entity,
                  entityId: this.id,
                },
                headers: {
                  'device-type': '2'
                },
                responseType: 'blob'
              }
            );
              const blob = new Blob([response.data], { 
              type: response.headers['content-type'] 
            });
            const url = URL.createObjectURL(blob);
                return {
                  ...attachment,
                  url: url,
                };

              } catch (error) {
                console.error("Error loading image:", error);
                return {
                  ...attachment,
                  url: ''
                };
              }
            })
          );
          this.isLoadAttachmentSuccess = true;
        }
      }).catch((error) => {
        console.error("Error loading attachments:", error);
        this.isLoadAttachmentSuccess = false;
      });
    },
    handleHidePreviewAttachment() {
      this.previewAttachment.visible = false;
    },
    showMultiplePreViewAttachment(indexOfFile) {
      const files = this.attachments.map((file) => ({
        src: file.url,
        title: file.fileName,
      }));
      this.previewAttachment.imgs = files;
      this.previewAttachment.index = indexOfFile;
      this.previewAttachment.visible = true;
    },
    onRemoveFile(fileCount, key) {
      fileCount = this.uploadedFiles.length;
      if (fileCount === 1) {
        this.uploadedFiles.splice(key, 1);
        this.reset();
      } else {
        this.uploadedFiles.splice(key, 1);
      }
    },
    onChangeFiles(fieldName, fileObject) {
      const formData = new FormData();
      for (const file of fileObject) {
        formData.append(fieldName, file, file.name);
      }
      this.saveToForm(formData);
    },
    saveToForm(formData) {
      this.currentStatus = FILE_UPLOAD_MODE.SAVING;
      generateImage(formData)
        .then((files) => {
          const fileNews = files.map(file => ({
            state: FILE_UPLOAD_STATUS.NEW,
            ...file,
          }));
          this.attachments = this.attachments.concat(fileNews);
          this.currentStatus = FILE_UPLOAD_MODE.SUCCESS;
        })
        .catch((err) => {
          this.uploadError = err.response;
          this.currentStatus = FILE_UPLOAD_MODE.FAILED;
        });
    },
    submitFiles() {
      const apiUrl = getApiUrlByEntity(this.entity);
      let formData = new FormData();
      for (const i of Object.keys(this.fileAttach.files)) {
        formData.append('files', this.fileAttach.files[i]);
      }
      formData.append('entity', this.entity);
      formData.append('entityId', this.id);
      this.currentStatus = FILE_UPLOAD_MODE.SAVING;
      axios
        .post(
          `${apiUrl.uploads}`,
          formData,
          {
            headers: {
              'device-type': '2'
            },
          },
        )
        .then((resp) => {
          if (resp.data.status === 1) {
            this.currentStatus = FILE_UPLOAD_MODE.SUCCESS;
            makeToastSuccess('Tải tệp lên thành công!');
            this.loadAttachments();
            // Clear preview files after successful upload
            this.uploadedFiles = [];
            this.fileAttach.files = [];
            this.fileCount = 0;
            // Xoá file đã upload bên dưới
            if (this.$refs['upload-files'] && this.$refs['upload-files'].$el) {
              const input = this.$refs['upload-files'].$el.querySelector('input[type="file"]');
              if (input) input.value = '';
            }
          }
        })
        .catch(() => {
          this.currentStatus = FILE_UPLOAD_MODE.FAILED;
          makeToastFaile('Tải tệp lên thất bại!');
        });
    },
    reset() {
      this.uploadError = null;
      this.currentStatus = FILE_UPLOAD_MODE.INITIAL;
      this.fileAttach.files = [];
      this.fileCount = 0;
    },
    handleFileUpload(event) {
      this.fileAttach.files = Array.from(event.target.files);

      this.fileCount = this.fileAttach.files.length;


      this.uploadedFiles = Array.from(event.target.files).map(file => ({
        file: file,
        fileName: file.name,
        originalName: file.name,
        url: URL.createObjectURL(file)
      }));

      this.currentStatus = STATUS_SUCCESS;
    },
    removeFile(fileCount, key) {
      this.uploadedFiles.splice(key, 1);

      this.fileAttach.files = this.fileAttach.files.filter((_, index) => index !== key);

      this.fileCount = this.uploadedFiles.length;

      if (this.uploadedFiles.length === 0) {
        this.reset();
      }
      makeToastSuccess('Đã xóa tệp');
    },
  },
};
</script>

<style lang="scss">
.upload-file {
  .dropbox {
    margin: auto;
    width: 70%;
    background: #f8f8f8;
    border-radius: 20px;
    color: dimgray;
    padding: 10px 10px;
    min-height: 200px;
    position: relative;
    cursor: pointer;
  }

  .input-file {
    opacity: 0;
    /* invisible but it's there! */
    left: 0px;
    width: 100%;
    height: 200px;
    position: absolute;
    cursor: pointer;
  }

  .dropbox:hover {
    background: #e8f5e9;
  }

  .dropbox p {
    font-size: 1.2em;
    text-align: center;
    padding: 50px 0;
  }

  .img-container {
    position: relative;
    display: inline-block;
    width: 80px;
    margin: 0px 10px;

    small {
      display: block;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      text-align: center;
      margin-top: 5px;
      font-size: 12px;
    }
  }

  .preview-img {
    max-width: 80px;
    padding: 10px;
    object-fit: contain;
    border: 1px solid #eeecff;
    border-radius: 5px;
  }

  .preview-img-container {
    border: 2px dashed #eeecff;
    padding: 2rem 1rem;
  }

  .preview-box {
    display: inline-block;
  }

  .close {
    position: absolute;
    top: 0px;
    right: 0px;
    width: 15px;
    cursor: pointer;
  }

  .remove {
    position: absolute;
    top: 0px;
    left: -4px;
    width: 15px;
    font-size: 1.54rem;
    cursor: pointer;
  }

  .cancel {
    color: #545454;
    text-decoration: none;
  }

  ::-webkit-scrollbar {
    width: 13px;
  }

  ::-webkit-scrollbar-track {
    background-color: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #d6dee1;
    border-radius: 20px;
    border: 3px solid transparent;
    background-clip: content-box;
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: #a8bbbf;
  }

  .d-flex {
    gap: 16px;
  }

  .text-black {
    color: #000000;
  }

  .text-danger {
    color: #dc3545;
  }

  .text-warning {
    color: #ffc107;
  }
}
</style>